import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL || "/api";

function Tracksuits() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCategories() {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/categories`);
        // Filter only tracksuits categories that are active
        const tracksuitsCategories = response.data.filter(
          (category) => 
            category.display_location === "tracksuits" && 
            category.status !== 0
        );
        setCategories(tracksuitsCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, []);

  const renderCategoryCard = (category) => (
    <Grid item xs={12} sm={6} md={3} key={category.id}>
      <Card
        elevation={4}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          borderRadius: 3,
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: 8,
          },
        }}
      >
        <Box
          component={Link}
          to={`/${category.slug}`}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <CardMedia
            component="img"
            image={category.image}
            alt={category.name}
            sx={{
              height: { xs: 260, md: 320 },
              objectFit: "contain",
              backgroundColor: "#ffffff",
              px: 2,
              pt: 2,
            }}
          />
          <CardContent sx={{ flexGrow: 1 }}>
            <Typography
              variant="h6"
              component="h3"
              sx={{
                textAlign: "center",
                fontWeight: 700,
                textTransform: "uppercase",
                mb: 1.5,
              }}
            >
              {category.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center", mb: 3 }}
            >
              {category.description}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                fontWeight: 600,
                borderRadius: 2,
                textTransform: "uppercase",
              }}
            >
              Design Now
            </Button>
          </CardContent>
        </Box>
      </Card>
    </Grid>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        variant="h2"
        component="h1"
        gutterBottom
        sx={{ textAlign: "center", mb: 2, fontWeight: 700 }}
      >
        Tracksuits
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textAlign: "center", mb: 6, maxWidth: 600, mx: "auto" }}
      >
        Design your custom tracksuits with our easy-to-use kit builder
      </Typography>

      {loading ? (
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          Loading...
        </Typography>
      ) : categories.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          No tracksuits categories available at the moment.
        </Typography>
      ) : (
        <Grid container spacing={4}>
          {categories.map((category) => renderCategoryCard(category))}
        </Grid>
      )}
    </Container>
  );
}

export default Tracksuits;

